import React from "react";
import InputField from "../../FormFields/InputField";

const MessageA14s = (props) => {
  props.setCodevalue(props?.item?.code)
  return
  //  (
  //   <div style={{ width: "90%", margin: "0 auto" }}>
  //     <InputField {...props} />
  //   </div>
  // );
};

export default MessageA14s;
